import { Base } from '../../../base/components/base'
import { Div } from '../../../base/components/native/div'
import device from '../../../base/helpers/device'
import { EASE } from '../../../base/helpers/style'
import ldb from '../../../base/lib/ldb'
import router, { IRouteParams } from '../../../base/lib/router'
import { waitFor } from '../../../base/utils/wait'
import helpers from '../../../helpers'
import db from '../../../services/db'


export const MenuPage = () => {

    const base = Base()
    const contents = Div()
    const title = Div('Helloprint AI Art 0.1.0.10')
    const history = Div('History')
    const login = Div('Login')
    const loggedIn = Div()
    const logout = Div('Logout')
    contents.append(title, history, login, loggedIn, logout)
    base.append(contents)

    history.el.onclick = () => router.goto('/history')
    login.el.onclick = () => router.goto('/login')
    logout.el.onclick = () => {
        ldb.clear()
        db.clear('general')
        db.clear('history')
        db.clear('favourites')
        login.style({ display: 'block' })
        loggedIn.style({ display: 'none' })
        logout.style({ display: 'none' })
        router.goto('/')
    }

    base.cssClass(helpers.styles.PAGE_BASE_STYLE)
    title.cssClass({ margin: '0 0 21px 0' })
    login.cssClass({ margin: '0 0 21px 0', cursor: 'pointer' })
    history.cssClass({ margin: '0 0 21px 0', cursor: 'pointer', '&:hover': {opacity: '.9'} })
    loggedIn.cssClass({ margin: '0 0 21px 0', fontSize: '16px' })
    logout.cssClass({ margin: '0 0 21px 0', cursor: 'pointer' })
    contents.cssClass({
        fontSize: '20px',
        overflowY: 'auto',
        overflowX: 'hidden',
        paddingLeft: '70px',
        paddingBottom: '50px',
        paddingTop: '20px',
        paddingRight: '50px',
        color: 'white',
    })

    return {
        ...base,
        async exit({ to = '' }: IRouteParams) {
            base.style(helpers.styles.PAGE_EXIT_STYLE)
            if (to === '/login') base.style(helpers.styles.PAGE_EXIT_UP_STYLE)
        },
        async enter({ from = '' }: IRouteParams) {
            if (device.isMobile()) await waitFor(200)
            if (from === '/') {
                base.style({ ...helpers.styles.PAGE_EXIT_STYLE, ...EASE(0) })
            }
            base.style({ ...helpers.styles.PAGE_ENTER_STYLE, ...EASE(.16) }, 50)

            const user = ldb.get('ai-art-user')?.profile?.email
            if (user !== undefined && user !== null && user !== '') {
                login.style({ display: 'none' })
                loggedIn.style({ display: 'block' })
                logout.style({ display: 'block' })
                loggedIn.html(`Logged in as: <br>${user}`)
            } else {
                login.style({ display: 'block' })
                loggedIn.style({ display: 'none' })
                logout.style({ display: 'none' })
            }
        }
    }
}